import { snakeCase } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Menu } from 'components/atoms/dropdown';
import {
  DateFieldFilter,
  DateFieldFilterOperationType,
} from '../../filters/date';

export const renderMenuItem = (
  type: DateFieldFilterOperationType,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | JSX.Element,
) => (
  <Menu.Item
    data-cy={`op.${type}`}
    key={type.toString()}
    className="date-criteria"
  >
    {getOperationOptionRenderer?.(type) ?? (
      <FormattedMessage
        id={`task_list.filters.${snakeCase(
          DateFieldFilterOperationType[type],
        )}`}
      />
    )}
  </Menu.Item>
);
